import {Typography, TypographyProps} from './Typography'

export const Subheader = ({...props}: Omit<TypographyProps, 'variant'>) => {
    return <Typography variant="subheader" {...props}/>
}